<template>
  <div class="pension-by-age">
    <div class="form--title">
      <!-- TITULO -->
      <PmwHeading size="paragraph-80" weight="weight-light">
        Pensão por idade
        <InfoTooltip
          :tooltipMinWidth="'240'"
          text="Valores vão ser acrescidos ao preço total por dia de hospedagem de cada faixa de idade, relativo ao café da manhã, almoço e/ou jantar. "
        />
      </PmwHeading>
    </div>

    <!-- BOTÃO DE ADICIONAR DIFERENCIAL -->
    <div v-if="!showInputs" class="form--row">
      <PmwButton
        :hasIcon="true"
        layout="outline"
        variation="blue-100"
        class="form--button"
        @click="showInputsHandler"
      >
        Adicionar diferencial
      </PmwButton>
    </div>

    <!-- INPUTS -->
    <div v-if="showInputs" class="form--row">
      <div class="pension-per-day-inputs">
        <PensionByAgeInputs
          v-for="(board, index) in fluctuationData.pensoes"
          :boardData="board"
          :key="`board-card-${index}`"
        />

        <!-- ICONE DE FECHAR -->
        <button class="remove-col--btn" @click="removePensionByAgeHandler">
          <Icon icon="x-icon" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import PmwButton from '@solucoes/components-lib-tmp/src/components/elements/PmwButton'
import PmwHeading from '@solucoes/components-lib-tmp/src/components/elements/PmwHeading'
import InfoTooltip from '@solucoes/components-lib-tmp/src/components/patterns/InfoTooltip'
import PensionByAgeInputs from './PensionByAgeInputs'

export default {
  name: 'PensionByAge',
  components: {
    PmwHeading,
    PmwButton,
    InfoTooltip,
    PensionByAgeInputs
  },

  props: {
    fluctuationData: {
      type: Object,
      default: () => ({})
    },

    /** Erros (array de erros que foram identificados pelo back-end) */
    errors: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      showInputs: this.fluctuationData.pensoes?.length,

      paxData: []
    }
  },

  watch: {
    paxData() {
      this.createObjects()
    },

    'fluctuationData.pensoes': {
      handler(newValue) {
        if (newValue?.length) {
          this.showInputsHandler()
        } else {
          this.showInputs = false
        }
      }
    }
  },

  methods: {
    async showInputsHandler() {
      if (!this.paxData?.length) {
        const { data } = await this.$hotel.getHotelPax(this.$route.params.id)
        this.paxData = data
      }

      this.showInputs = true

      this.createObjects()
    },

    /**
     * Cria os objetos para as pensoes
     * caso não existam
     */
    createObjects() {
      if (!this.fluctuationData.pensoes?.length) {
        if (!this.fluctuationData.pensoes) this.fluctuationData.pensoes = []

        this.paxData.forEach((item) => {
          this.fluctuationData.pensoes.push({
            idadeMinimaPax: item.idadeMinima,
            idadeMaximaPax: item.idadeMaxima,
            codigoPax: item.codigo,
            tipoPax: item.tipoPax,
            valorCafe: null,
            valorAlmoco: null,
            valorJanta: null,
            valorTotal: null,
            checkinFlexivel: false,
            checkoutFlexivel: false,
            limiteUso: null
          })
        })
      } else {
        const outFields = this.paxData.filter(
          (item) =>
            this.fluctuationData.pensoes?.findIndex(
              (itemApi) => itemApi.codigoPax === item.codigo
            ) < 0
        )

        outFields.forEach((item) => {
          this.fluctuationData.pensoes.push({
            idadeMinimaPax: item.idadeMinima,
            idadeMaximaPax: item.idadeMaxima,
            codigoPax: item.codigo,
            tipoPax: item.tipoPax,
            valorCafe: null,
            valorAlmoco: null,
            valorJanta: null,
            valorTotal: null,
            checkinFlexivel: false,
            checkoutFlexivel: false,
            limiteUso: null
          })
        })
      }
    },

    removePensionByAgeHandler() {
      this.showInputs = false
      this.fluctuationData.pensoes = []
    }
  }
}
</script>

<style lang="scss" scoped>
.pension-per-day-inputs {
  position: relative;
  padding: pmw-space(2) pmw-space(3);
  border: 1px solid pmw-colors(grey-20);

  .remove-col {
    &--btn {
      @include reset-button();
      position: absolute;
      top: pmw-space(2);
      right: pmw-space(2);

      .icon {
        width: 12px;
        height: 12px;
        color: $gray-dark;
        transition: color 0.8s;

        &:hover {
          color: red;
        }
      }
    }
  }
}
.form {
  &--button {
    max-width: 185px;
    width: 185px;
  }

  &--row {
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 24px;
    margin-bottom: 32px;
  }

  &--title {
    margin-bottom: 24px;
    position: relative;
  }
}
</style>
